/**
 * Phase 4 — canonical referral sources. Mirrors backend/src/config/referralSources.ts.
 *
 * The old option list was a plain string array copy-pasted into ManagerCreateUserView and
 * ManagerUserView, which is how "CDL Consultant" and "CDL Consultants" ended up as two sources.
 * Codes here, labels for display; the API accepts only the codes.
 */

export const REFERRAL_SOURCES = [
  'CDL_CONSULTANTS',
  'CDL_LEGAL',
  'TVC',
  'OTR',
  'LEGALEASE',
  'METLIFE',
  'LRIS',
  'AVVO',
  'SIMPLEX',
  'ARAG',
  'US_LEGAL',
  'TEXAS_LEGAL',
  'LEGAL_SHIELD',
  'REPEAT',
  'GOOGLE',
  'OTHER',
] as const;

export type ReferralSource = (typeof REFERRAL_SOURCES)[number];

export const REFERRAL_SOURCE_LABELS: Record<ReferralSource, string> = {
  CDL_CONSULTANTS: 'CDL Consultants',
  CDL_LEGAL: 'CDL Legal',
  TVC: 'TVC',
  OTR: 'Off the Record',
  LEGALEASE: 'LegalEase',
  METLIFE: 'MetLife',
  LRIS: 'LRIS',
  AVVO: 'AVVO',
  SIMPLEX: 'Simplex',
  ARAG: 'ARAG',
  US_LEGAL: 'US Legal',
  TEXAS_LEGAL: 'Texas Legal',
  LEGAL_SHIELD: 'Legal Shield',
  REPEAT: 'Repeat',
  GOOGLE: 'Google',
  OTHER: 'Other',
};

export function referralSourceLabel(code: string | null): string {
  if (!code) return 'Not set';
  return REFERRAL_SOURCE_LABELS[code as ReferralSource] ?? code;
}
